<template>
<div class="bg-c f-t" style="height: 100%;">
	<div class="bg-f" style="height: 35px; border-bottom: 1px solid #409eff;overflow: hidden; position: relative;flex-shrink: 0;">
		<div :style="{width:getsize.width-300+'px'}" style="height: 20px;">
			<p v-for="(name,index) in getname" :key="index" :ref="name" class="tab" :class="index==getindex?'tabch':'tabn'" @click="tabchoose(index)">
				<span v-if="index==getindex"></span>
				{{name}}
				<i class="el-icon-circle-close" v-if="index!==0" @click.stop="tabclose(index)"></i>
			</p>
		</div>
		<div class="more" v-if="hidetab.length">
			<el-dropdown @command="command" style="width: 100%;">
				<span class="el-dropdown-link" style="font-size: 22px;text-align: center;line-height: 30px;color: #562409;display: inline-block;width: 100%;">
					<i class="el-icon-arrow-down el-icon-menu"></i>
				</span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item v-for="(item,i) in hidetab" :key="i" :command="i">{{item}}</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
	</div>
	<div class="fg1" style="overflow: auto;">
		<!-- <keep-alive :include="getrouter"> -->
			<router-view></router-view>
		<!-- </keep-alive> -->
	</div>
</div>
</template>

<script>
import { mapGetters,mapMutations } from 'vuex'
export default{
	name: "mytab",
	data() {
		return{
			showtab:[],
			hidetab:[],
			bool:true
		}
	},
	computed:{
		...mapGetters('Tabs',['getrouter','getname','getindex']),
		...mapGetters(['getsize'])
	},
	watch:{
		// getname(newdata,olddada){
		// 	if(newdata.length!==olddada.length){
		// 		this.bool=true
		// 	}
		// },
		getname(){
			this.bool=true
		}
	},
	methods:{
		...mapMutations('Tabs',['setindex','deltab','repshow']),
		async tabchoose(i){
			if(i===this.getindex) return
			this.setindex(i)
			try {
				await this.$router.push({name:this.getrouter[i]})
			}catch{
				console.log("页面重新跳转")
			}
		},
		tabclose(i){
			this.deltab(i)
			if(this.getindex===i){
				this.$router.push({name:this.getrouter[i-1]})
			}
			if(this.getindex>=i){
				this.setindex(this.getindex-1)
			}
		},
		command(data){
			this.repshow({i:this.showtab.length-1,j:this.showtab.length+data})
			this.setindex(-1)
			this.tabchoose(this.showtab.length-1)
		}
	},
	updated() {
		if(this.bool){
			this.showtab=[]
			this.hidetab=[]
			this.getname.forEach(e=>{
				const height =this.$refs[e][0].getBoundingClientRect().top
				if(height<100){
					this.showtab.push(e)
				}else{
					this.hidetab.push(e)
				}
			})
			this.bool=false
		}
		if(this.getindex>=this.showtab.length){
			this.repshow({i:this.showtab.length-1,j:this.getindex})
			this.tabchoose(this.showtab.length-1)
		}
		
	}
}
</script>

<style>
.tab{
	float: left;
	margin-top: 8px;
	height: 20px;
	line-height: 20px;
	margin-left: 10px;
	padding: 3px 28px 3px 13px;
	font-size: 14px;
	background: #ccf;
	border-top: 1px solid #343;
	border-radius: 3px;
	color: #343;
	position: relative;
	z-index: 10;
	cursor: default;
}
.tab::before{
	content: "";
	width: 20px;
	height: 100%;
	background: #ccf;
	border-right: 1px solid #343;
	border-top-right-radius: 3px;
	position: absolute;
	right: -8px;
	top: 0px;
	transform: skew(30deg);
}
.tab::after{
	content: "";
	width: 15px;
	height: 100%;
	background: #ccf;
	border-left: 1px solid #343;
	border-top-left-radius: 3px;
	position: absolute;
	left: -5px;
	top: 0px;
	transform: skew(-20deg);
}
.tab:first-child{
	padding-right: 18px;
}
.tabch{
	z-index: 20;
	padding-left: 20px;
	background: #409eff;
	color: #ff0;
}
.tabch::before{
	background: #409eff;
}
.tabch::after{
	background: #409eff;
}
.tabch >span::before{
	content: "";
	display: block;
	position: absolute;
	width: 4px;
	height: 4px;
	background: #ff0;
	border-radius: 2px;
	top: 11px;
	left: 5px;
	z-index: 22;
}
.tabch >span:hover::before{
	background: #fff;
}
.tab >i{
	position: absolute;
	z-index: 22;
	right: 2px;
	top: 4px;
	width: 18px;
	height: 18px;
	text-align: center;
	line-height: 18px;
	border-radius: 9px;
}
.tabn:hover{
	color: #999;
}
.tab >i:hover{
	background: #999;
	color: #fff;
}
.tabch:hover{
	color: #fff;
}
.tabch >i:hover{
	background: #666;
	
}
.more{
	height: 30px;
	width: 40px;
	position: absolute;
	right: 5px;
	top: 0px;
	
	border-radius: 3px;
	
}
.more:hover{
	background: #ccc;
}
</style>
